import React from 'react';

const CropGrid: React.FC = () => (
    <div className="absolute inset-0 pointer-events-none">
        {[1/3, 2/3].map(pos => (
            <React.Fragment key={pos}>
                <div className="absolute top-0 bottom-0 border-l border-white/30" style={{left: `${pos * 100}%`}}/>
                <div className="absolute left-0 right-0 border-t border-white/30" style={{top: `${pos * 100}%`}}/>
            </React.Fragment>
        ))}
    </div>
);

export default CropGrid;
